import { Controller } from "@hotwired/stimulus";
import { FormClearable } from "../shared/form_clearable";
import { NestedFormRenumber } from "../shared/nested_form_renumber";
import { NestedFormMaxNumber } from "../shared/nested_form_max_number";

// Connects to data-controller="resumin--form-removal"
// このコントローラーは、フォームの要素を削除しますが、必ず1個以上の要素が残るようにします。
export default class extends Controller {
  static targets = ["protected"];
  static values = {
    containerId: String,
    otherClearEnabled: { type: Boolean, default: false },
  };

  connect() {
    FormClearable(this);
    NestedFormRenumber(this);
    NestedFormMaxNumber(this);
  }

  remove(e) {
    e.preventDefault();
    const container = this._getContainer();
    const count = container.querySelectorAll(
      'li[data-controller~="resumin--form-removal"]',
    ).length;

    this.protectedTargets.forEach((target) => {
      const action = target.dataset["resumin-FormRemovalActionWithRemove"];
      if (action) {
        this._invokeAction(target, action, e);
      }

      const cloneTarget = target.cloneNode(true);
      container.appendChild(cloneTarget);
    });

    if (count <= 1) {
      this._clearFormValues();
      if (this.otherClearEnabledValue) this._clearOtherValues(e);
    } else {
      this.element.remove();
    }
  }

  _invokeAction(target, action, event) {
    const [controllerName, methodName] = action.split("#");
    const controller = this.application.getControllerForElementAndIdentifier(
      target,
      controllerName,
    );

    if (controller) {
      controller[methodName](event);
    }
  }

  // protectedTargets以外の要素をクリアします。
  _clearFormValues() {
    const elements = this.element.querySelectorAll("input, select, textarea");
    const container = this._getContainer();
    const ids = container.querySelectorAll(
      '[data-resumin--form-removal-max-number-value="target"]',
    );
    const index = this.maxNumberFromId(ids) + 1;

    Array.from(elements).forEach((input) => {
      this.renumber(input, index);
      this.clearElement(input);
    });
  }

  _clearOtherValues(e) {
    const clearArea = e.target.closest(
      "[data-resumin--form-removal-target='enabledOtherClearArea']",
    );
    if (!clearArea) return;

    clearArea
      .querySelectorAll("[data-resumin--form-removal-other-clear-value]")
      .forEach((element) => {
        const addClass = element.dataset["resumin-FormRemovalAddClassValue"];
        const removeClass =
          element.dataset["resumin-FormRemovalRemoveClassValue"];
        if (addClass) {
          element.classList.add(addClass);
        }
        if (removeClass) {
          element.classList.remove(removeClass);
        }
        element.innerHTML =
          element.dataset["resumin-FormRemovalOtherClearValue"];
      });
  }

  _getContainer() {
    return document.getElementById(this.containerIdValue);
  }
}
